import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { FindConfigurationResponse } from "../models/dto/configuration-find";
import { UtilityCommon } from "../../utils/utility-common";
import { ServicePathsSettings } from "../../../core/configuration/service-paths-settings";
import { Configuration, ConfigurationFeature } from "../models/configuration";
import { ConfigurationData } from "../stores/data-configuration-store";
import { BehaviorSubject, Observable, map, tap } from "rxjs";
import { pdaConfiguration } from "src/app/pda/utils/pda-configuration";
import { AppData } from "src/app/data-store";

@Injectable({
  providedIn: "root",
})
export class ConfigurationService {
  private _configurazione = new BehaviorSubject<boolean>(false);
  config = this._configurazione.asObservable();
  constructor(private http: HttpClient, private configurationData: ConfigurationData ) {}

  public configurationLoaded(state: boolean) {
    this._configurazione.next(state);
  }

  public getConfigurations(): Observable<Configuration[]> {
    return this.http
      .get<FindConfigurationResponse>(
        ServicePathsSettings.DOMINIO + ServicePathsSettings.CONFIGURATION_PATH
      )
      .pipe(
        tap((it) => console.log("[initConfiguration]", "[tap]", it)),
        map((response) => {
          // response.items.push({
          //   "feature": "DASHBOARD",
          //   "enabled": true,
          //   "properties": {}
          // })
          return response.items;
        })
      );
  }

    getParameter(parameterName: string): Observable<any> {
      const url = ServicePathsSettings.DOMINIO + ServicePathsSettings.OPERATIONS_PATH + `/gp/protocols/file/${parameterName}`;
      return this.http.get<{ value: any }>(url);
    }

  private isConfigurationEnabled(configs: Configuration[], feature: string): boolean {
    if(!configs) return false;
    let config: Configuration = configs.find(c => c.feature ===  feature);
    return config?.enabled || false;
  }

  public isFeatureEnabled(feature: string) {
    const configs = JSON.parse(localStorage.getItem("configurations"));
    return this.isConfigurationEnabled(configs, feature);
  }

  public isFeaturePdaEnabled() {
    const configs = AppData.getInstance().configurations;
    return this.isConfigurationEnabled(configs, ConfigurationFeature.JUSTICE_PDA);
  }

}
